import { gql, useMutation } from '@apollo/client';
import { TTranslator } from '@smartshell/ui-kit';

import { TLocalesKeys } from 'localization';
import {
  ISetUserDiscountRequest,
  ISetUserDiscountResponse,
  SET_USER_DISCOUNT,
} from 'schemas';
import notification from 'services/notificationService';

import { TSetDiscount } from './interfaces';

export const useSetDiscount = (t: TTranslator<TLocalesKeys>): TSetDiscount => {
  const [setDiscount] = useMutation<
    ISetUserDiscountResponse,
    ISetUserDiscountRequest
  >(SET_USER_DISCOUNT, {
    update: (cache, { data }) => {
      const user = data?.setUserDiscount;

      if (!user) return;

      cache.writeFragment({
        id: cache.identify(user),
        data: user,
        fragment: gql`
          fragment discount on User {
            user_discount
          }
        `,
      });
    },
    onCompleted: () => {
      notification.info({
        t,
        title: t('clients.discountChanged'),
        type: 'success',
        dismiss: 5,
      });
    },
  });

  return setDiscount;
};
